<template>
  <v-dialog
    v-model="value"
    max-width="500px"
    @click:outside="() => {}"
    @keydown.esc="close"
    persistent
  >
    <v-card style="border-radius: 8px">
      <v-card-text style="padding: 0; margin: 0">
        <div class="confirm-title">수락 실패</div>
        <div class="content-paragraph">
          <div class="content-paragraph-title">
            최대 심사자 수를 초과하여 수락할 수 없습니다.
          </div>
          <div class="content-paragraph-text">
            활성 가능한 심사자 수를 확인해 주세요.
          </div>
          <div class="content-paragraph-sub">
            현재 활성화된 수 {{ currentReviewer }}/{{ maxReviewer }}
          </div>
        </div>
        <div class="button-container">
          <div v-ripple @click="close" class="button ok">취소</div>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  components: {},
  props: {
    value: {
      type: Boolean,
      default: false,
    },

    confirmInfos: {
      type: Object,
    },
    reviewerMaxAdminError: {
      type: Number,
      require: true,
    },
    reviewerCurrentAdmin: {
      type: Number,
      require: true,
    },
  },

  computed: {
    currentReviewer() {
      return this.fillZero(2, String(this.reviewerCurrentAdmin));
    },
    maxReviewer() {
      return this.fillZero(2, String(this.reviewerMaxAdminError));
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
    confirm() {
      this.$log.debug('this.confirmDialogInfo, event');
      this.$emit('confirmation', this.confirmInfos.item.id);
      this.$emit('close');
    },
    fillZero(width, str) {
      return str.length >= width
        ? str
        : new Array(width - str.length + 1).join('0') + str; //남는 길이만큼 0으로 채움
    },
  },
};
</script>

<style lang="scss" scoped>
.confirm-title {
  text-align: center;
  padding: 40px 0px 32px 0px;
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  line-height: 36px;
  color: var(--surface-high);
}
.content-paragraph {
  //   width: 336px;
  justify-content: center;
  display: flex;
  flex-direction: column;
  //   margin: 0 82px 0 82px;

  .name {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: black;
  }
  .id {
    margin-left: 4px;
    color: var(--surface-medium);
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 24px;
  }
}
.content-paragraph > div {
  display: flex;
  flex-direction: row;
  justify-content: center;
  height: 24px;
}
.content-paragraph-title {
  font-weight: 500;
  font-size: 1.25rem;
  line-height: 2rem;
  color: var(--primary-100);
  margin-bottom: 8px;
}
.content-paragraph-text {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  letter-spacing: -0.5px;
  color: var(--surface-high);
  margin-bottom: 8px;
}
.content-paragraph-sub {
  width: 173px;
  height: 32px;
  /* Gray/100 */

  background: var(--gray-100);
  border-radius: 8px;
  margin: 0 auto;
}

.content-user-info {
  display: flex;
  flex-direction: row;
}
.content-change-info {
  display: flex;
  flex-direction: row;
  margin-left: 20px;
}
.content-change-info > div {
  color: var(--surface-high);

  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;

  .active {
    width: 30px;
  }
  .inactive {
    width: 45px;
  }
}
.button-container {
  display: flex;
  width: 100%;
  padding: 40px 40px;
  .button {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    font-weight: 500;
    font-size: 1rem;
    height: 60px;
    cursor: pointer;

    &.cancel {
      width: 100%;
      color: var(--surface-medium);
      margin-right: 10px;
      background: var(--gray-100);
    }

    &.ok {
      width: 100%;
      color: var(--surface-100);
      background: var(--primary-100);
    }
  }
}
</style>
